import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Moment from '../../helpers/momentUtils'
import CSSTransitionGroup from 'react-addons-css-transition-group'
import OffersCarouselDay from './OffersCarouselDay'
import Icon from '../Icon/Icon'
import Alert from '../Alert/Alert'
import './OffersCarousel.scss'
import { extendMoment } from 'moment-range'

const moment = extendMoment(Moment)

class OffersCarousel extends Component {
  state = {
    alertEnabled: false,
    leftButtonEnabled: true,
    dayInView: '',
    carouselPosition: 0,
  }

  componentDidUpdate() {
    const { prevSelectedFlights, route } = this.props
    const { alertEnabled } = this.state

    const maxFlights = this.getSelectedFlights().length === 3
    if (prevSelectedFlights === route.id && !maxFlights && alertEnabled) {
      this.toggleAlert()
    }
  }

  createFlightDaysPlaceholder = () => {
    const daysArray = this.createDatesRange(this.props.route.dateRange)
    return daysArray.map(day => ({
      date: day,
      flights: {
        morning: [],
        afternoon: [],
        evening: [],
      },
    }))
  }

  toggleAlert = () => {
    const selectedFlights = this.getSelectedFlights()
    this.setState({
      ...this.state,
      alertEnabled: selectedFlights.length === 3,
    })
  }

  isBetweenTimes = (time, start, end) => {
    return time.isBetween(start, end) || time.isSame(end)
  }

  groupFlightsByDay = (flights, flightDays) => {
    flights.forEach(flight => {
      const {
        outboundFlight,
        outboundFlight: { departureDateTime },
      } = flight
      const departureTime = moment(departureDateTime)
      const flightDay = flightDays.find(day =>
        moment(day.date).isSame(departureTime, 'day')
      )
      const morning = moment(departureDateTime).set({ hour: 0, minute: 0 })
      const afternoon = moment(departureDateTime).set({ hour: 12, minute: 0 })
      const evening = moment(departureDateTime).set({ hour: 18, minute: 0 })

      if (this.isBetweenTimes(departureTime, morning, afternoon)) {
        flightDay.flights.morning.push(outboundFlight)
      } else if (this.isBetweenTimes(departureTime, afternoon, evening)) {
        flightDay.flights.afternoon.push(outboundFlight)
      } else {
        flightDay.flights.evening.push(outboundFlight)
      }
    })

    return flightDays
  }

  createDatesRange = dateRange => {
    const dates = dateRange.split('-')
    const start = moment(dates[0]).format('YYYYMMDD')
    const end = moment(dates[dates.length - 1]).format('YYYYMMDD')
    const range = moment.range(start, end)
    const datesList = Array.from(range.by('day'))

    return datesList.map(date => date.format('YYYY-MM-DD'))
  }

  getSelectedFlights = (flightsRoutes = this.props.selectedFlights) => {
    const selectedFlightsRoute = flightsRoutes.find(
      r => r.routeId === this.props.route.id
    )
    return selectedFlightsRoute ? selectedFlightsRoute.flights : []
  }

  moveCarousel = direction => {
    const sign = direction === 'left' ? -1 : 1
    const dayInView = moment(this.state.dayInView)
      .add(sign * 1, 'days')
      .format('YYYYMMDD')
    const range = this.props.route.dateRange.split('-')
    const carouselRange = moment.range(moment(range[0]), moment(range[1]))
    const theNewDay = moment(this.state.dayInView).add(sign * 2, 'days')
    let carouselPosition = this.state.carouselPosition

    if (!theNewDay.within(carouselRange)) {
      this.props.getAdditionalFlights(this.props.route.id, direction)
    } else {
      carouselPosition += direction === 'left' ? 100 / 3 : 0
    }

    carouselPosition -= direction === 'right' ? 100 / 3 : 0

    this.setState({
      ...this.state,
      dayInView,
      carouselPosition,
    })
    this.updateCarouselButtons(dayInView)
  }

  updateCarouselButtons(day) {
    const currentDay = moment()
    const dayInView = moment(day).subtract(1, 'days')
    const difference = dayInView.diff(currentDay, 'days', true)

    if (difference <= 0) {
      this.setState({ leftButtonEnabled: false })
    } else if (difference > 0 && !this.state.leftButtonEnabled) {
      this.setState({ leftButtonEnabled: true })
    }
  }

  componentDidMount() {
    const range = this.props.route.dateRange.split('-')
    const dayInView = moment(range[0])
      .add(1, 'days')
      .format('YYYYMMDD')
    this.setState({
      ...this.state,
      dayInView,
    })
    this.updateCarouselButtons(dayInView)
  }

  render() {
    const { alertEnabled, leftButtonEnabled, carouselPosition } = this.state
    const {
      route,
      name: routeName,
      setSelectedFlight,
      error,
      labels,
    } = this.props
    const flightDaysPlaceholder = this.createFlightDaysPlaceholder(
      route.flightOffers
    )
    const flightDays = this.groupFlightsByDay(
      route.flightOffers,
      flightDaysPlaceholder
    )
    const selectedFlights = this.getSelectedFlights()
    const carouselHolderStyle = {
      transform: `translateX(${carouselPosition}%)`,
    }

    return (
      <div className="OffersCarousel__wrapper">
        <h2>
          <Icon name={route.type} className="OffersCarousel__icon" />
          <span className="-green">{routeName}</span>
        </h2>
        {alertEnabled && (
          <Alert type="information" className="OffersCarousel__alert">
            {route.type === 'inbound'
              ? labels['maxInboundError']
              : labels['maxOutboundError']}
          </Alert>
        )}
        {error && (
          <Alert type="error" className="OffersCarousel__alert">
            {route.type === 'inbound'
              ? labels['invalidInboundError']
              : labels['invalidOutboundError']}
          </Alert>
        )}
        <div className="OffersCarousel__section">
          <button
            className={`OffersCarousel__control
              ${!leftButtonEnabled && 'disabled'}`}
            onClick={leftButtonEnabled ? () => this.moveCarousel('left') : null}
          >
            <Icon name="arrow-left" />
          </button>
          <div className="OffersCarousel">
            <CSSTransitionGroup
              className="OffersCarousel__holder"
              component="div"
              transitionName="carousel"
              transitionEnterTimeout={10}
              transitionLeaveTimeout={10}
              style={carouselHolderStyle}
            >
              {flightDays.map(day => (
                <OffersCarouselDay
                  day={day}
                  routeType={route.type}
                  routeId={route.id}
                  handleClick={setSelectedFlight}
                  handleDisabledClick={this.toggleAlert}
                  selectedFlights={selectedFlights}
                  disabled={selectedFlights.length === 3}
                  key={day.date}
                />
              ))}
            </CSSTransitionGroup>
          </div>
          <button
            className="OffersCarousel__control"
            onClick={() => this.moveCarousel('right')}
          >
            <Icon name="arrow-right" />
          </button>
        </div>
      </div>
    )
  }
}

OffersCarousel.propTypes = {
  route: PropTypes.object.isRequired,
  name: PropTypes.string,
  selectedFlights: PropTypes.array.isRequired,
  setSelectedFlight: PropTypes.func.isRequired,
  getAdditionalFlights: PropTypes.func.isRequired,
  prevSelectedFlights: PropTypes.string,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  labels: PropTypes.shape({
    maxInboundAlertMessage: PropTypes.string,
    maxOutboundAlertMessage: PropTypes.string,
    invalidInboundAlertMessage: PropTypes.string,
    invalidOutboundAlertMessage: PropTypes.string,
  }),
}

export default OffersCarousel
